//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDynamicEnv } from "@/assets/js/appFunc";

export default {
    name: "AQAvatarUploader",
    props: {
        allowedExtensions: { type: String, default: ".jpg, .png, .svg" },
        disabled: { type: Boolean },
        errorStyle: { type: Boolean },
        envVariable: { type: String, default: "UPLOAD_LIMIT_AVATAR" },
        avatarImage: { type: String, default: "" }
    },
    data() {
        return {
            uploadedData: [],
            openTriggerElem: null,
            updateButtonDisabled: false,
            currentLang: "en",
            errorState: false,
            avatar: "",
            avatarFromPrv: ""
        };
    },
    computed: {
        showMaxSize() {
            return getDynamicEnv(this.envVariable);
        }
    },
    watch: {
        avatarImage: {
            handler() {
                this.avatar = this.avatarImage || this.avatarFromPrv;
            }
        }
    },
    mounted() {
        this.currentLang = localStorage.getItem("language") || "en";
        this.avatar = this.avatarImage;
    },
    activated() {
        this.avatar = this.avatarImage;
    },
    methods: {
        selectFile() {
            if (!this.disabled) {
                this.errorState = false;
                this.$refs.file.click();
            }
        },
        deleteFile() {
            this.avatar = null;
            this.avatarFromPrv = null;
            this.$refs.file.value = "";
            this.removeAvatar();
        },
        previewImage(e) {
            const image = e.target.files[0];
            const allowedFileTypes = ["image/jpeg", "image/png", "image/svg+xml"];

            if (allowedFileTypes.indexOf(image.type.toLowerCase()) === -1) {
                this.errorState = true;
                e.target.value = null;
                return false;
            }
            if (image.size > this.showMaxSize.bytesSize) {
                this.errorState = true;
                e.target.value = null;
                return false;
            }

            this.avatar = image;
            this.avatarFromPrv = image;

            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = ev => {
                this.avatar = ev.target.result;
                this.avatarFromPrv = this.avatar;
            };
            this.added(this.avatar);
            return false;
        },
        removeAvatar() {
            this.$emit("removeAvatar");
        },
        added(ev) {
            this.$emit("added", ev);
        }
    }
};
